import React from 'react';
import { Helmet } from "react-helmet";

const SITE_URL = "https://harsofts.com";
const DEFAULT_DESCRIPTION = "Harsoft Solutions is a software development company and web development company delivering mobile app development, AI development services, SaaS development, and Python development for businesses worldwide.";
const DEFAULT_IMAGE = `${SITE_URL}/assets/img/logo/Harsoft_Logo_Color_svg.svg`;

const PageHelmet = ({ pageTitle, description, keywords, path = "/", noIndex = false }) => {
    const title = `${pageTitle} | Harsoft Solutions`;
    const metaDescription = description || DEFAULT_DESCRIPTION;
    const canonicalUrl = `${SITE_URL}${path}`;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={metaDescription} />
            {keywords && <meta name="keywords" content={keywords} />}
            <meta name="robots" content={noIndex ? "noindex, follow" : "index, follow"} />
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Harsoft Solutions" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={DEFAULT_IMAGE} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={DEFAULT_IMAGE} />
        </Helmet>
    );
};

export default PageHelmet;
